import '../sass/wishlist.sass';

declare const Routing: any;
declare global {
    interface Window {
        dataLayer: any[];
    }
}

document.addEventListener("DOMContentLoaded", function () {
    const favoriteCounter = document.querySelector('.favorites__counter');

    document.body.addEventListener("click", async function (e) {
        const target = (e.target as HTMLElement).closest(".add-to-wishlist-btn, .remove-from-wishlist-btn, .toggle-wishlist") as HTMLElement;
        if (!target) return;

        e.preventDefault();

        const filmId = target.dataset.filmId;
        const filmTitle = target.dataset.filmTitle;
        let elementToRemove = null;
        if (target.dataset.remove) {
            elementToRemove = document.querySelector(target.dataset.remove);
        }
        const iconList = document.querySelectorAll('[data-film-id="' + filmId + '"].toggle-wishlist') as NodeListOf<HTMLElement>;

        const beforeAdd = () => {
            iconList.forEach(icon => {
                icon.classList.remove("add-to-wishlist-btn");
                icon.classList.add("active");
            });
        };

        const resetAdd = () => {
            iconList.forEach(icon => {
                icon.classList.add("add-to-wishlist-btn");
                icon.classList.add("active");
            });
        };

        const afterAdd = (data: any) => {
            iconList.forEach(icon => {
                icon.classList.add("remove-from-wishlist-btn");
                const heart = icon.querySelector("i.fa-heart-o");
                if (heart) {
                    heart.classList.remove("fa-heart-o");
                    heart.classList.add("fa-heart");
                }
                icon.parentElement.classList.add("wishlist-active");
                icon.title = icon.dataset.deleteLabel;
            });

            if (favoriteCounter) favoriteCounter.innerHTML = data;
        };

        const beforeRemove = () => {
            iconList.forEach(icon => {
                icon.classList.remove("remove-from-wishlist-btn");
                icon.classList.remove("active");
            });
        };

        const resetRemove = () => {
            iconList.forEach(icon => {
                icon.classList.add("remove-from-wishlist-btn");
                icon.classList.add("active");
            });
        };

        const afterRemove = (data: any) => {
            iconList.forEach(icon => {
                const heart = icon.querySelector("i.fa-heart");
                if (heart) {
                    heart.classList.remove("fa-heart");
                    heart.classList.add("fa-heart-o");
                }
                icon.parentElement.classList.remove("wishlist-active");
                icon.classList.add("add-to-wishlist-btn");
                icon.title = icon.dataset.addLabel;

                // fadeOut replacement
                const filmItem = icon.closest(".film-item") as HTMLElement;
                if (filmItem) {
                    setTimeout(() => {
                        filmItem.style.transition = "opacity 0.3s ease";
                        filmItem.style.opacity = "0";

                        setTimeout(() => {
                            filmItem.style.display = "none";
                        }, 300);
                    }, 3000);
                }
            });

            if (favoriteCounter) favoriteCounter.innerHTML = data;
        };

        // Determine action (add/remove)
        const isAdding = target.classList.contains("add-to-wishlist-btn");
        const url = isAdding
            ? Routing.generate("user_wishlist_add", { filmId })
            : Routing.generate("user_wishlist_remove", { filmId });

        // Call beforeSend equivalent
        if (isAdding) beforeAdd();
        else beforeRemove();

        try {
            const response = await fetch(url, { method: "GET" });

            if (response.status === 201 || response.status === 200) {
                const data = await response.json();

                if (isAdding) {
                    // growl_message(Translator.trans("film.added_in_wishlist", {}, "messages"));
                    afterAdd(data);
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({'ecommerce': null});
                    window.dataLayer.push({
                        'event': 'add_to_wishlist',
                        'ecommerce': {
                            'items': [{
                                'item_id': filmId,
                                'item_name': filmTitle
                            }]
                        }
                    });
                } else {
                    // growl_message(Translator.trans("film.removed_from_wishlist", {}, "messages"));
                    afterRemove(data);
                    if (elementToRemove) {
                        elementToRemove.remove();
                    }
                }
            }

            else if (response.status === 401) {
                if (isAdding) {
                    // error_message(Translator.trans('film.add_in_wishlist.user.not_connected', {}, 'messages'));
                    resetAdd();
                } else {
                    // error_message(Translator.trans('film.remove_in_wishlist.user.not_connected', {}, 'messages'));
                    resetRemove();
                }
            }

        } catch (err) {
            console.error("Wishlist request failed:", err);
            if (isAdding) resetAdd();
            else resetRemove();
        }
    });
});